import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", { class: "text-xl leading-8 block font-normal text-gray-500 mt-[1.3333333em]" }, "The nslookup command line tool uses your system's DNS stub resolver by default. This resolver uses your ISP's DNS servers if you haven't changed them. You can overwrite this default setting by specifying a DNS server in the command itself.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "To query a specific DNS server in nslookup, add the server's IP or hostname at the end of your command. For example:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("pre", null, "nslookup isc.org 8.8.8.8", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Nslookup will now use Google's DNS server — running at the IP address 8.8.8.8 — to query the DNS records of isc.org.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "The syntax for nslookup is:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("pre", null, "nslookup [-option ...] domain-name [dns-server]", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("figure", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full rounded-lg",
    src: "/img/learning/how-to-specify-a-dns-server-in-nslookup/nslookup-specific-dns-server.png",
    alt: "A specific DNS server in nslookup",
    title: "A specific DNS server in nslookup",
    width: "1216",
    height: "691"
  }),
  /*#__PURE__*/_createElementVNode("figcaption", null, "A specific DNS server in nslookup.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you ever forget the order of nslookup's parameters, remember that you can check them from the command line.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("On Windows, you can type "),
  /*#__PURE__*/_createElementVNode("code", null, "nslookup /?"),
  /*#__PURE__*/_createTextVNode(" to get a short help message.")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("On Linux and macOS, type "),
  /*#__PURE__*/_createElementVNode("code", null, "man nslookup"),
  /*#__PURE__*/_createTextVNode(" instead.")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Specifying the port number", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("DNS uses port 53. But some DNS servers listen on a different port. In that case, you'll have to tell nslookup to use that port instead. You can change the port nslookup uses by adding the "),
  /*#__PURE__*/_createElementVNode("code", null, "-port=42"),
  /*#__PURE__*/_createTextVNode(" option.")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "For example:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("pre", null, "nslookup -port=42 isc.org 8.8.8.8", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "Setting a DNS server in nslookup's interactive mode", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("You can run nslookup in interactive mode by typing "),
  /*#__PURE__*/_createElementVNode("code", null, "nslookup"),
  /*#__PURE__*/_createTextVNode(" without a domain name. This way, you can keep an nslookup session open. To set the DNS server in interactive mode, enter "),
  /*#__PURE__*/_createElementVNode("code", null, "server 8.8.8.8"),
  /*#__PURE__*/_createTextVNode(" to switch to Google's public DNS servers.")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("pre", null, "% nslookup\nDefault Server:  UnKnown\nAddress:  fe80::21c:42ff:fe00:18\n\n> server 8.8.8.8\nDefault Server:  dns.google\nAddress:  8.8.8.8\n\n> set port=53", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("If you use the DNS server's hostname, then nslookup needs to resolve that to an IP address. It will try to do so with the currently set DNS server. If that server can't resolve the IP address of the new DNS server, then you can use "),
  /*#__PURE__*/_createElementVNode("code", null, "lserver"),
  /*#__PURE__*/_createTextVNode(" instead. This will instruct nslookup to use your local DNS resolver instead of the one set in this nslookup session.")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There is no difference between "),
  /*#__PURE__*/_createElementVNode("code", null, "server"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("code", null, "lserver"),
  /*#__PURE__*/_createTextVNode(" if you use the DNS server's IP address.")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", null, "Looking up DNS records at multiple servers", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "The nslookup command line tool doesn't have any way to check DNS records at multiple servers at once. You need to run the command multiple times if you want to check multiple servers.", -1)
const _hoisted_22 = {
  class: "not-prose text-base mx-auto max-w-lg mt-10",
  autocomplete: "off"
}

import BlogPost from '@/components/layout/BlogPost.vue';


import { ruurtjan } from '@/common/authors';
import { BlogMeta } from '@/common/blogMeta';
import DomainSearch from '@/components/DomainSearch.vue';
import Callout from '@/components/layout/CalloutComponent.vue';
import { commandLineToolsBreadcrumb, learningBreadcrumb } from '@/model/Breadcrumb';
import { useRouter } from 'vue-router';
import { domainNameToUrlPath } from '@/common/domainName';

export const meta: BlogMeta = {
  tag: 'Command line tools',
  url: '/learning/how-to-specify-a-dns-server-in-nslookup/',
  breadcrumbs: [learningBreadcrumb, commandLineToolsBreadcrumb],
  title: 'How to specify a DNS server in nslookup?',
  description: 'Nslookup uses your system\'s DNS server by default. You can change by specifying a DNS server in the command itself. Here\'s how.',
  overviewDescription: 'Nslookup uses your system\'s DNS server by default. You can change by specifying a DNS server in the command itself. Here\'s how.',
  overviewImage: '/img/learning/how-to-specify-a-dns-server-in-nslookup/nslookup-specific-dns-server.png',
  overviewImageAlt: 'A specific DNS server in nslookup',
  author: ruurtjan,
  editor: undefined,
  img1024x512: 'https://www.nslookup.io/img/learning/how-to-specify-a-dns-server-in-nslookup/nslookup-specific-dns-server.png',
  img1200x630: 'https://www.nslookup.io/img/learning/how-to-specify-a-dns-server-in-nslookup/nslookup-specific-dns-server.png',
  written: new Date('2023-03-09T13:16:08.799Z'),
  updated: new Date('2023-03-11T11:39:31.105Z'),
};

const __default__ = {
  meta,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'HowToSpecifyADnsServerInNslookup',
  setup(__props) {

const router = useRouter();

function redirectTo(domain: string): void {
  router.push(`/domains/${domainNameToUrlPath(domain)}/dns-propagation/a/`);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BlogPost, {
    title: meta.title,
    description: meta.description,
    url: `https://www.nslookup.io${meta.url}`,
    breadcrumbs: meta.breadcrumbs,
    img1024x512: meta.img1024x512,
    img1200x630: meta.img1200x630,
    written: meta.written,
    updated: meta.updated,
    author: meta.author,
    editor: meta.editor
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode(Callout, {
        icon: "info",
        title: "Checking the nslookup documentation from the command line",
        heading: "h2"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      }),
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _hoisted_21,
      _createElementVNode("p", null, [
        _createTextVNode("A simpler way to check the DNS propagation for a domain name is using our "),
        _createVNode(_component_router_link, { to: "/dns-checker/" }, {
          default: _withCtx(() => [
            _createTextVNode("DNS checker")
          ]),
          _: 1
        }),
        _createTextVNode(". This will show you the DNS records at global and regional DNS servers.")
      ]),
      _createElementVNode("form", _hoisted_22, [
        _createVNode(DomainSearch, {
          emphasize: "",
          onSubmitted: redirectTo
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "description", "url", "breadcrumbs", "img1024x512", "img1200x630", "written", "updated", "author", "editor"]))
}
}

})